var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wikiData != null)?_c('div',[_c('Search'),_c('b-list-group',_vm._l((_vm.wikiData.resources),function(url,id){return _c('WikiEntry',{key:id,attrs:{"url":url}})}),1),_c('MentionSelector'),_c('DragDrop')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }